import { render, staticRenderFns } from "./WPTextInfoMain.vue?vue&type=template&id=8167eb16"
import script from "./WPTextInfoMain.vue?vue&type=script&lang=ts"
export * from "./WPTextInfoMain.vue?vue&type=script&lang=ts"
import style0 from "./WPTextInfoMain.vue?vue&type=style&index=0&id=8167eb16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports